import { DefaultMarkerIcon } from "@App/Components/atoms/map/markerIcons/DefaultMarkerIcon";
import { CpmLogo } from "@App/Components/atoms/whitelabel/logos/CpmLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the CPM whitelabel.
 * Extends the default configuration with specific settings for CPM.
 */
export const config: Partial<Config> = {
  slug: "cpm",
  navbar: {
    logos: {
      left: {
        component: <CpmLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.carprofessional.de/",
    },
  },
  reviews: {
    show: true,
  },
  map: {
    MarkerIcon: DefaultMarkerIcon,
    markerContent: "earliestSlot",
  },
};

export default config;
